// src/services/userService.js
import api from './api';

export const fetchUserProfile = () => api.get('/core/users/me/');

export const updateUserProfile = (payload) => {
  if (payload instanceof FormData) {
    return api.patch('/core/users/me/', payload);
  }
  return api.patch('/core/users/me/', payload);
};
